import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { apiCreateCheckout, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const BENEFITS = [
  "Unlimited Live Crypto Market Analysis",
  "2 Expert Reviews per month",
  "Weekly Bitcoin Market Outlooks",
  "Expert Reviews delivered within 3 business days",
  "Early Access to New Features",
];

export default function MembershipPage() {
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const buy = async () => {
    setBusy(true);
    try {
      const origin = window.location.origin;
      const { url } = await apiCreateCheckout(origin);
      if (!url) throw new Error("No checkout URL returned");
      window.location.href = url;
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(false);
    }
  };

  return (
    <section className="pt-12 md:pt-20 max-w-2xl mx-auto pb-20" data-testid="membership-page">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="border-2 border-[#00E5FF]/40 bg-[#00E5FF]/[0.04] p-8"
      >
        <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#00E5FF] mb-6">
          ── members only ──
        </div>

        <h1 className="text-3xl sm:text-4xl font-black tracking-tighter text-white leading-tight">
          ChartLenz Membership
        </h1>
        <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
          One plan, everything included. Cancel anytime.
        </p>

        <div className="mt-6 mb-6 border border-neutral-900 bg-black/40 p-5">
          <div className="flex items-baseline gap-2 mb-1">
            <span className="font-black text-4xl text-white" data-testid="member-price">€9.99</span>
            <span className="text-sm font-mono text-neutral-500 uppercase tracking-[0.15em]">/ month</span>
          </div>
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500 mb-4">
            recurring · auto-renew via Stripe · Cancel anytime
          </div>
          <ul className="space-y-2.5" data-testid="member-benefits">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-center gap-2.5 text-sm text-neutral-200">
                <Check className="w-4 h-4 flex-shrink-0" style={{ color: "#00FF66" }} />
                {b}
              </li>
            ))}
          </ul>
        </div>

        <button
          onClick={buy}
          disabled={busy}
          data-testid="become-member-btn"
          className="w-full inline-flex items-center justify-center gap-2 bg-white text-black font-bold text-sm uppercase tracking-wider px-6 py-3 hover:bg-neutral-200 transition-colors disabled:opacity-50"
        >
          {busy ? "Redirecting to Stripe…" : <>Become a Member <ArrowRight className="w-4 h-4" /></>}
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          data-testid="member-skip"
          className="w-full text-center text-xs text-neutral-500 mt-4 hover:text-white transition-colors"
        >
          Not now
        </button>
      </motion.div>
    </section>
  );
}
